import { useContext } from 'react';
import IntlContext from './use-intl.esm7.js';

function useIntlContext() {
  var context = useContext(IntlContext);

  if (!context) {
    throw new Error(process.env.NODE_ENV !== 'production' ? 'No intl context found. Have you configured the provider?' : undefined);
  }

  return context;
}

export { useIntlContext as default };
//# sourceMappingURL=use-intl.esm8.js.map
